import { axios } from '@/api/common';


export default {
    sendResetPasswordEmail(emailParam) {
        return axios.post('/Member/SendResetPasswordEmail', { email: emailParam }).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    resetPassword(memberCode, newPassword) {
        return axios.post('/Member/ResetPassword', {
            memberCode,
            newPassword
        }).then((response) => {
            return {
                isError: false,
                data: response.data
            };
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response?.data?.error_description
            };
        });
    },
    IsMailUnique(email) {
        return axios.get('/Member/IsMailUnique?Email=' + email).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    IsMailUnique_ForUpdate(memberId, email) {
        return axios.get('/Member/IsMailUnique_ForUpdate?MemberId=' + memberId + '&Email=' + email).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    IsPhoneNumberUnique(phone) {
        return axios.get('/Member/IsPhoneNumberUnique?Phone=' + phone).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    IsPhoneNumberUnique_ForUpdate(memberId, phone) {
        return axios.get('/Member/IsPhoneNumberUnique_ForUpdate?MemberId=' + memberId + '&Phone=' + phone).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    encryptLogin(model) {
        return axios.post('/Member/EncryptLogin', model).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    encryptMember(model) {
        return axios.post('/Member/EncryptMember', model).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    decryptMember(model) {
        return axios.post('/Member/DecryptMember', model).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    /**
     * The Turnstile token travels in a header rather than in the body: the body is the
     * encrypted member model, and the token is neither encrypted nor stored. The API
     * posts it to Cloudflare and rejects the registration with 403 if it does not check out.
     */
    addNewMember(member, turnstileToken) {
        var config = turnstileToken
            ? { headers: { 'CF-Turnstile-Response': turnstileToken } }
            : {};

        return axios.post('/Member/AddNewMember', member, config).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            var response = error.response;
            return {
                isError: true,
                status: response ? response.status : 0,
                errorDecription: response && response.data ? response.data.error_description : undefined,
                // A 422 carries the CRM's own field errors, which is the only thing that can
                // tell the registrant which box to change. Without this they were dropped
                // here and the form could only say "please try again".
                errors: response && response.data ? response.data.errors : undefined
            }
        });
    },
    updateMember(member) {
        return axios.post('/Member/UpdateMember', member).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getMemberId(email, password) {
        return axios.get('/Member/GetMemberId?Email=' + email + '&Password=' + password).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getMember(email, password) {
        return axios.get('/Member/GetMember?Email=' + email + '&Password=' + password).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getMember_2(memberId) {
        return axios.get('/Member/GetMember_2?MemberId=' + memberId).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getCountries() {
        return axios.post('/Member/GetCountries').then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getCities(countryId) {
        return axios.get('/Member/GetCities?CountryId=' + countryId).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    getCommLanguages() {
        return axios.post('/Member/GetCommLanguages').then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    SendUserListDownloadedMail(memberId) {
        return axios.post('/Member/SendUserListDownloadedMail?memberId=' + memberId).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    addTempMember(member) {
        return axios.post('/Member/AddTempMember', member).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    verifyMember(code) {
        return axios.post('/Member/VerifyMember', code).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    },
    resendCodes(code) {
        return axios.post('/Member/ResendCodes', code).then((response) => {
            if (response.status == 200) {
                return {
                    isError: false,
                    data: response.data
                };
            }
        }).catch((error) => {
            return {
                isError: true,
                errorDecription: error.response.data.error_description
            }
        });
    }
}
